export default class GrupoViewModel {
	constructor () {
		this.Id = undefined;
		this.UsuarioId = undefined;
		this.UsuarioLiderId = undefined;
		this.NomeUsuario = undefined;
		this.NomeGrupo = undefined;
		this.CodigoExterno = undefined;
		this.Login = undefined;
		this.Senha = undefined;
		this.ConfirmacaoSenha = undefined;
		this.GrupoSelecionado = undefined;
		this.Email = undefined;
		this.Bloqueado = undefined;
		this.Inativo = undefined;
		this.DataTrocaSenha = undefined;
		this.GrupoId = undefined;
		this.EditarSenha = undefined;
	}
}